import { cn } from "@/lib/cn";

export function MeshBackdrop({ className }: { className?: string }) {
	return (
		<div
			aria-hidden
			className={cn(
				"pointer-events-none absolute inset-0 -z-10 bg-surface-raised",
				"bg-[radial-gradient(ellipse_at_top,var(--color-zinc-100),transparent_55%)]",
				"dark:bg-[radial-gradient(ellipse_at_top,var(--color-zinc-800),transparent_55%)]",
				className,
			)}
		/>
	);
}
